<div
  class="alert"
  [ngClass]="'alert--' + type"
  role="alert">
  <mat-icon class="alert__icon">{{ icon }}</mat-icon>

  <div class="alert__message">
      <span *ngIf="message" [innerHTML]="message"></span>
  </div>
  <div ><ng-content></ng-content></div>
</div>

